module.exports = __webpack_public_path__ + "static/media/card-DNK.8708b0fc.svg";